import axios from "axios";

export default {
    namespaced: true,

    state: {},

    mutations: {},

    actions: {
        getMedicalRecordActiveParts({}, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/appointments/${id}/medical-record-active-parts`)
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        buildForm({}, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/record/build/${id}`)
                    .then((res) => {
                        resolve(res.data.data.form);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getPatientInfo({}, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/record/patient/info/${id}`)
                    .then((res) => {
                        resolve(res.data.data.info);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getPatientFiles({}, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/record/patient/files/${id}`)
                    .then((res) => {
                        resolve(res.data.data.files);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getValues({}, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/record/values/${id}`)
                    .then((res) => {
                        resolve(res.data.data.values);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        saveItemValue({}, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/medico/record/items/value", payload)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        saveItemFileValue({}, payload) {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                for (const i in payload) {
                    if (payload[i] !== null && i !== "files_value") {
                        formData.append(i, payload[i]);
                    }
                }
                const files_value = payload.files_value;
                for (const val in files_value) {
                    formData.append(`files_value[${val}]`, files_value[val]);
                }
                axios
                    .post("/medico/record/items/value", formData)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        finishAppointment({}, id) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/medico/record/finish/${id}`)
                    .then((res) => {
                        resolve(res.data.data.appointment);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        reopenAppointment({}, id) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/medico/record/reopen/${id}`)
                    .then((res) => {
                        resolve(res.data.data.appointment);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getCertificateTypes({}) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/medico/record/certificate/types")
                    .then((res) => {
                        resolve(res.data.data.types);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getVideoAccessToken({}, appointmentId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/video/appointment/${appointmentId}/doctor`)
                    .then((res) => {
                        resolve(res.data.token);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        downloadCertificate({}, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        '/medico/record/certificate',
                        payload,
                        {
                            responseType: "blob",
                        }
                    )
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        downloadMedicalRecordReport({}, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/record/report/${id}`, {
                        responseType: "blob",
                    })
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        saveChartingExceptionAnswersToAppointment(_, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/medico/record/exceptions/${payload.charting_by_exception_id}/${payload.appointment_id}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        emrPdf({}, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/record/emr/${id}`, {
                        responseType: "blob",
                    })
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
};
